export type { LineToProps } from './LineTo.types'
export { default as LineTo } from './LineTo'